export function isItemOriginallyInventoryReordered(item) {
  return Boolean(item.originalInventoryId && item.isReorder);
}